module.exports = __webpack_public_path__ + "static/media/home_banner_4.0a9334a6.jpg";